import styled from "@emotion/styled";
import { pxToRem } from "../../../design/utils";
import { GridItem } from "./Grid";

export const Header = styled(GridItem)<{ ereader?: boolean }>`
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: repeat(12, minmax(0, 1fr));

  height: ${pxToRem(44)};
  position: sticky;
  top: 0;
  align-items: center;
  justify-content: space-between;
  ${({ theme, ereader }) =>
    ereader
      ? theme.layers.relief.accent_20.shadow
      : theme.layers.relief.uiGrey_10.shadow};
  padding: ${({ theme }) => theme.spacing(0.75)};
  z-index: 5;
`;
